import Backbone from 'backbone';
import $ from 'jquery';
import * as utilities from '@bingads-webui-campaign-legacy/editorial-appeal/utilities';
import EditorView from '@bingads-webui-campaign-legacy/editorial-appeal/view/editor';
import InlineErrorView from '@bingads-webui-campaign-legacy/editorial-appeal/view/inline-error';

const legacy$ = $;

export default class InlineAppealView extends Backbone.View {
  initialize({
    grid,
    rowId,
    controller,
    submit,
    appealTitle,
    disableAppealBtn,
    permissions,
  }) {
    this.grid = grid;
    this.rowId = rowId;
    this.appealTitle = appealTitle;
    this.controller = controller;
    this.submit = submit;
    this.disableAppealBtn = disableAppealBtn;
    this.permissions = permissions;
  }

  render() {
    utilities.getAppealRejections(
      this.controller,
      'GetAppealRejections',
      [this.rowId],
      {
        grid: this.grid,
        success: this.onInlineAppealSuccess.bind(this),
        error: () => {
          this.grid.expandRowDetail(this.rowId, null, true, false);
        },
        jsonError: () => {
          const inlineErrorView = new InlineErrorView({
            rowId: this.rowId,
            callback: () => {
              this.cancelInlineAppeal(this.grid, this.rowId);
            },
          }).render();

          this.grid.expandRowDetail(this.rowId, inlineErrorView.$el, true, true);
        },
        permissions: this.permissions,
      }
    );

    return this;
  }

  onInlineAppealSuccess({ appealIds, appealData: [firstAppealData = {}] }) {
    if (firstAppealData.IsAppealable) {
      this.editor = new EditorView({
        appealData: firstAppealData,
        controlId: `inlineAppeal_${this.rowId}`,
        callback: this.callBackForInlineAppeal.bind(this),
        appealTitle: this.appealTitle,
        hideAppealCheckBox: true,
      });

      this.editor.render();

      this.editor.toInline(appealIds, this.rowId, this.disableAppealBtn, {
        appeal: () => {
          this.createInlineAppeal(appealIds);
        },
        cancel: () => {
          this.grid.expandRowDetail(this.rowId, null, true, false);
          this.grid.cancelInlineUpdates();
        },
      });

      this.trigger('success');
    }
  }

  createInlineAppeal(appealIds) {
    if (this.editor && legacy$(`#inlineAppealForm_${this.rowId}`).valid()) {
      let params = utilities.ids2params(appealIds);

      const appealJson = this.editor.getAppealData();

      if (appealJson) {
        params += `&EditorialAppeal.Appeal=${appealJson.Appeal}&EditorialAppeal.EntityType=${appealJson.EntityType}&EditorialAppeal.Justification=${appealJson.Justification}`;
      }

      this.grid.bulkAction(
        utilities.getInlineBulkAppealUrl(this.controller, this.submit),
        params,
        null,
        this.onCreateAppealSuccess.bind(this),
        { grid: this.grid, rowId: this.rowId }
      );
    }
  }

  onCreateAppealSuccess(data, { grid, rowId }) {
    if (data) {
      this.cancelInlineAppeal(grid, rowId);
    }
  }

  cancelInlineAppeal(grid, rowId) {
    grid.expandRowDetail(rowId, null, true, false);
    grid.cancelInlineUpdates();
    this.trigger('cancel');
  }

  callBackForInlineAppeal(appealHtml) {
    this.grid.expandRowDetail(this.rowId, appealHtml, true, true);
    this.editor.setElement($(`#EditorialAppeal_Full_${this.editor._elementId}`).parent());
  }
}
